/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UnlinkBusinessRequest} from '@cash-web/protos/squareup/franklin/app/business.pb'
import {UnlinkBusinessResponse} from '@cash-web/protos/squareup/franklin/app/business.pb'


export const unlinkBusiness = (request: UnlinkBusinessRequest, options?: CashRequestOptions) => post<UnlinkBusinessRequest, UnlinkBusinessResponse>("/2.0/cash/unlink-business", request, {...options, rejectOnError: true })